import type { ApiAttachedResource, UpdateActivityPayload } from './interfaces';
import type { Course } from '@/models/catalog/course';
import type { EmbeddedCourse } from '@/models/resources';

export const buildAttachedResource = (
  attachedResource?: UpdateActivityPayload['attached_resource']
): ApiAttachedResource | null => {
  if (!attachedResource) {
    return null;
  }

  if (attachedResource.external_link) {
    return { type: 'external_link', data: attachedResource.external_link };
  }

  if (attachedResource.course) {
    if ('source' in attachedResource.course) {
      return { type: 'embedded_course', data: attachedResource.course as EmbeddedCourse };
    }

    return { type: 'marketplace_course', data: attachedResource.course as Course };
  }

  return null;
};
